<template>
  <div>
    <div class="d-flex align-center">
      <v-icon color="indigo darken-1" class="mr-3" size="28">mdi-cog</v-icon>
      <h3 class="mb-0">Create Proposals</h3>
    </div>
    <v-card class="pa-4">
      <div v-if="!preview">
        <!-- Editing -->
        <h3 class="mb-4 text-center">Proposal Editing</h3>
        <div>Proposal Content *</div>
        <v-textarea
            v-model="content"
            outlined
            dense
            color="primary"
            :rules="[rules.required]"
        ></v-textarea>

        <div class="mt-4">
          <div>Spending Requirement to vote (in USDC)*</div>
        </div>
        <v-text-field
            v-model="spendingRequirement"
            dense
            outlined
            type="number"
            color="primary"
            :rules="[rules.required, rules.positive]"
            @wheel="$event.target.blur()"
        ></v-text-field>

        <div class="mt-4">
          <div>Voting Period (in Days) *</div>
        </div>
        <v-text-field
            v-model="period"
            dense
            outlined
            type="number"
            color="primary"
            :rules="[rules.required, rules.positive]"
            @wheel="$event.target.blur()"
        ></v-text-field>

        <h4 class="mt-8">Voting Items: </h4>

        <v-row class="my-4">
          <v-col class="col-6" v-for="(_, index) in votingOptions" :key="index">
            <div>
              <div>Option {{index + 1}}:</div>
              <div class="d-flex">
                <v-text-field
                    v-model="votingOptions[index]"
                    outlined
                    hide-details
                    dense
                    color="primary"
                ></v-text-field>
                <v-icon class="ml-2" @click="deleteVotingOption(index)">mdi-trash-can</v-icon>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-btn block small class="mb-8" @click="addVotingOption">
          <v-icon color="indigo lighten">mdi-plus-circle-outline</v-icon>
        </v-btn>

        <div class="d-flex justify-end">
          <v-btn outlined color="indigo darken-1" @click="previewProposalHandle">Preview</v-btn>
        </div>
      </div>

      <!-- Preview -->
      <div v-if="preview">
        <div class="d-flex align-center mb-4">
          <v-icon color="grey darken-1" class="mr-3 cursor-pointer" size="28" @click="toEditHandle">mdi-arrow-left-circle</v-icon>
          <h3>Preview:</h3>
        </div>
        <ProposalCard
            :proposalData="proposalData"
            :proposalContent="proposalContent"
            :votingPeriods="period"
        ></ProposalCard>
        <v-btn color="indigo darken-1" class="mt-4" block dark @click="createProposal" :loading="createProposalLoading">Confirm</v-btn>
      </div>
    </v-card>

    <ConfirmationDialog
        :dialogShow="confirmationDialog"
        status="success"
        msg="Success to create new proposal"
        :confirmationCallback="successCallback"
        btnName="Back"
    >
    </ConfirmationDialog>
  </div>
</template>

<script>
import ProposalCard from "@/components/ProposalList/ProposalCard"
import Vue from 'vue';
import backendCall from "@/lib/backendCall/index";
import ethCall from "@/lib/eth/ethCall";
import config from "@/config";
import ethUtil from "@/lib/eth/util";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "ProposalCreate",
  components: {
    ConfirmationDialog,
    ProposalCard
  },
  computed: {
    proposalData() {
      return {
        spendingRequirement: parseInt(this.spendingRequirement * (10 ** config.commonConfig.paymentCoinDecimal))
      }
    },
    proposalContent() {
      return {
        content: this.content,
        options: this.votingOptions
      }
    }
  },
  data() {
    return {
      preview: false,
      content: "",
      period: 10,
      spendingRequirement: null,
      votingOptions: [],
      createProposalLoading: false,
      confirmationDialog: false,
      rules: {
        required: value => !!value || 'Required.',
        positive: value => parseInt(value) >= 0 || 'Positive number'
      }
    }
  },
  methods: {
    addVotingOption(){
      this.votingOptions.push("")
    },
    deleteVotingOption(index){
      this.votingOptions.splice(index, 1)
    },
    previewProposalHandle(){
      this.preview = true
    },
    toEditHandle(){
      this.preview = false
    },
    async createProposal(){
      this.createProposalLoading = true
      try {
        const res = await backendCall.proposal.createProposal(this.content, this.votingOptions)
        if (res.status === 0){
          throw Error(res.message)
        } else if (res.status === 1){
          const proposal = res.data
          await ethCall.proposalFactory.newProposal(proposal.id, this.spendingRequirement * (10 ** config.commonConfig.paymentCoinDecimal), this.votingOptions.length, 0, this.period * 60 * 60 *24)
          this.confirmationDialog = true
        }
      }catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        console.error(e)
        if (revertMsg) {
          Vue.notify({
            type: "error",
            text: revertMsg
          })
        }else {
          Vue.notify({
            type: "error",
            text: "Fail to create proposal"
          })
        }
      }finally {
        this.createProposalLoading = false
      }
    },
    successCallback() {
      this.$router.push({name: 'proposal'})
    }
  }
}
</script>

<style scoped>

</style>